export default async function (method, body = {}, headers = {}) {
    const url = `${rozetka_learnpress_global.restApi.url}${method}`

    try {

        const response = await fetch(url,
            {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "X-WP-Nonce": rozetka_learnpress_global.restApi.nonce,
                    ...headers
                },
                body: JSON.stringify(body)
            })

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Fetch error: ", error)
        throw error
    }
}